import React from 'react';
import { Box } from '@ui';
import { useOutletContext } from 'react-router-dom';

import { MainSettingsForm } from './blocks/main-settings';
import { MonitoringFormSettingsOutletType } from './monitoring-forms-settings.outlet';

const QmManageMonitoringFormsSettingPage = () => {
  const { monitoringFormData, analyticsProjects } =
    useOutletContext<MonitoringFormSettingsOutletType>();
  return (
    <Box className="mt-[42px] p-[45px_0px_0px_75px]">
      <MainSettingsForm
        monitoringFormData={monitoringFormData}
        analyticsProjects={analyticsProjects}
      />
    </Box>
  );
};

export default QmManageMonitoringFormsSettingPage;
